<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert, Button, ListItem, Loader, Modal, Stack, Text } from '@Shelly/shelly-design-system';

	//Stores
	import { user_data } from 'src/stores/account/user';
	import { saved_wifi_neworks } from 'src/stores/features/wifi/passwords';

	import { nonShellyNetworks } from 'src/stores/features/inclusion';
	import { mobile } from 'src/services/mobile-rework';
	import { getAvailableNetworks } from 'src/helpers/get_gen_2_networks';

	export let inclusionData;

	const defaultMaxShowed = 9;
	let maxShowedNetworks = defaultMaxShowed;
	let showMore = false;
	let showModal = false;
	let waitForResponse = false;
	let networksListError = '';

	let wifiList = $nonShellyNetworks;

	const formatNetworksList = (networks) => {
		const checkDuplicateList = [];
		const networksList = [];

		networks.forEach((network) => {
			if (checkDuplicateList.indexOf(network) == -1) {
				const icon = `fa-wifi`;

				networksList.push({
					value: network,
					title: network,
					icon,
				});
				checkDuplicateList.push(network);
			}
		});
		return networksList;
	};

	const resetShowMore = () => {
		showMore = false;
		maxShowedNetworks = defaultMaxShowed;
	};

	const onSelect = (networkItem) => {
		showModal = false;
		resetShowMore();

		if (
			inclusionData.wifi.ssid !== networkItem.value &&
			$saved_wifi_neworks &&
			$saved_wifi_neworks[$user_data?.email]?.ssid !== networkItem.value
		) {
			inclusionData.wifi.pass = '';
		}

		inclusionData.wifi.ssid = networkItem.value;
	};

	const closeModalOnAndroidBack = (e: CustomEvent) => {
		if (showModal) {
			e.preventDefault();
			showModal = false;
		}
	};

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModalOnAndroidBack);
			return () => mobile.removeEventListener('back_button', closeModalOnAndroidBack);
		}
	});
</script>

<Button
	size="m"
	width="full"
	variant="secondary"
	class="mb-s"
	on:click={() => {
		showModal = true;
		// getAvailableNetworks();
	}}
	loading={waitForResponse}
>
	{$format('choose-wifi-networks', {
		default: 'Choose Wi-Fi network',
	})}
</Button>

{#if showModal}
	<Modal
		on:close={() => {
			showModal = false;
			resetShowMore();
		}}
		{showModal}
		backdropClose={true}
		title={$format('available_networks', { default: 'Available networks' })}
	>
		<svelte:fragment slot="content">
			{#if wifiList.length <= 0}
				<div class="d-flex justify-content-center align-items-center flex-direction-column">
					<Loader class="mb-xs" />
					<Text styleType="controls-small" class="text-center text-bold">
						{$format('title_scanning', {
							default: 'Scanning ...',
						})}
					</Text>
				</div>
			{:else if wifiList.length > 0}
				<Stack gap="s">
					{#each formatNetworksList(wifiList) as networkItem, i}
						{#if i < maxShowedNetworks}
							<ListItem
								viewType="fullColored"
								listItemBgColor="--color-1"
								icon={'fa-duotone ' + networkItem.icon}
								actionBtn
								title={networkItem.title}
								on:click={() => onSelect(networkItem)}
							/>
						{/if}
					{/each}

					{#if !showMore}
						<ListItem
							viewType="more"
							listItemBgColor="--color-1"
							title={$format('show_more_network_items', {
								values: {
									networkItems: wifiList.length - maxShowedNetworks,
								},
								default: `+${wifiList.length - maxShowedNetworks} ${$format('more', {
									default: 'more',
								})}`,
							})}
							actionBtn
							on:click={() => {
								showMore = true;
								maxShowedNetworks = wifiList.length;
							}}
						/>
					{/if}
				</Stack>
			{:else}
				<Alert type="danger" heading={networksListError} class="mb-s" />
				<Button
					size="m"
					class="width-full mr-s text-capitalized"
					responsiveSize={{
						sm: 'm',
					}}
					variant="primary"
					on:click={getAvailableNetworks}
				>
					{$format('button_rescan', { default: 'Rescan' })}
				</Button>
			{/if}
		</svelte:fragment>
	</Modal>
{/if}
